import React from 'react';
import { useSvgIconStylesContext } from './SvgIconStylesContext';

export interface SvgIconFactoryParams {
    Svg: (props: React.SVGAttributes<unknown>) => JSX.Element;
    displayName: string;
}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type. */
export default function CreateSvgIcon({ Svg, displayName }: SvgIconFactoryParams): any {
    const IconComponent: React.FC<React.SVGAttributes<unknown>> = () => {
        const { iconStyles } = useSvgIconStylesContext();
        return <Svg className={iconStyles} />;
    };

    IconComponent.displayName = displayName;

    return IconComponent;
}
